import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getCurrentLanguage } from 'library-@/utils/getCurrentLanguage';

Vue.use(VueI18n);


export const i18n = new VueI18n({
    locale: getCurrentLanguage(),
    messages: {},
});

export function useI18n() {
    function t(key: string, values?: VueI18n.Values | undefined) {
        return i18n.t(key, values);
    }

    return {
        t,
        locale: i18n.locale,
    };
}
